import { ReactNode } from 'react';
import { Stack, Typography } from '@optimus-web/core';

interface CardHeaderProps {
    title: ReactNode;
    value: number;
}

export const CardHeader = ({ title, value }: CardHeaderProps) => (
    <Stack spacing="100">
        <Typography textStyle="bodyMediumStrong" variant="primary" as="div">
            {title}
        </Typography>
        <Typography textStyle="bodyMedium" variant="tertiary" as="div">
            {value}
        </Typography>
    </Stack>
);
